/**
 * Où mène une notification au chemin court `home`, pour un élève.
 *
 * Le serveur l'envoie surtout pour les activités (« Il te reste des activités aujourd'hui », les
 * relances d'activités), et l'ancien accueil ÉTAIT la liste des activités. Le nouvel accueil n'en
 * montre plus (Wajih, 17/10) : l'élève de l'espace du design system arrive donc sur l'onglet
 * Activités, ce que l'ancien accueil lui montrait. Interrupteur éteint, en live ou en mode parent,
 * rien ne change : l'accueil d'aujourd'hui (le mode parent est tranché avant, par le gestionnaire).
 *
 * Décidé la nuit du 18/10 (parité par défaut), à valider : toutes les notifications `home` d'un
 * élève, pas seulement celles d'activités — le serveur ne les distingue pas, et c'était déjà
 * l'écran où elles menaient.
 */
import { isStudentSpaceRouteOn } from "./studentSpaceBridge"

export function studentHomePushPath(state: unknown): "menu/activities" | "menu/home" {
    return isStudentSpaceRouteOn(state) ? "menu/activities" : "menu/home"
}
